import config from "@/config/config"

function loadRecaptcha() {
  const recaptchaScript = document.createElement('script')
  recaptchaScript.setAttribute('src', config.recaptchaSrc)
  document.head.appendChild(recaptchaScript)
}

export {
  loadRecaptcha
}
